import { ApiConfig } from '../request'
import post, { PostAxiosRequestConfig } from './post'

/**
 * upload 请求，继承自post
 * @param name 接口名称
 * @param data 请求参数
 * @param config axios配置参数
 */
export default function upload<RESD, REQD = any> (name: string, data?: REQD, custom?: ApiConfig, config?: PostAxiosRequestConfig) {
  return post<RESD, REQD>(name, data, custom, config)
}
